import styled from 'styled-components'
import Button from '@mui/material/Button'

interface ActiveCartProps {
  borderActive?: boolean
  inNavigationComponent?: boolean
}

interface CartProps {
  size?: 'medium' | 'root'
}

export const Cart = styled(Button).attrs<CartProps>(({ size }) => ({
  variant: 'outlined',
  color: 'textColor',
  size: size || 'root',
}))`
  padding: 0 !important;
  /* background-color: transparent;
  border-radius: 4px;
  height: 40px;
  padding: 0 2px;
  position: relative;
  transition: ease-in-out 0.2s;
  width: 40px;
  z-index: 1; */
`

export const NumberItems = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme?.colors?.error};
  border-radius: 50%;
  color: ${({ theme }) => theme?.colors?.white};
  display: flex;
  font-size: 10px;
  justify-content: center;
  height: 18px;
  right: -8px;
  position: absolute;
  top: -8px;
  width: 18px;
`

type ContainerProps = {
  beforeBackground?: string
}
export const ContainerCart = styled.div<ContainerProps>`
  color: ${({ theme }) => theme.colors.textColor};
  background-color: ${({ theme }) => theme?.colors?.white ?? '#FFFFFF'};
  border-radius: 4px;
  width: 306px;
  -webkit-box-shadow: 0px 0px 15px 0px rgba(39, 50, 64, 0.3);
  -moz-box-shadow: 0px 0px 15px 0px rgba(39, 50, 64, 0.3);
  box-shadow: 0px 0px 15px 0px rgba(39, 50, 64, 0.3);
  z-index: 1;
  margin-top: 10px;

  p {
    color: ${({ theme }) => theme.colors.textColor};
  }
`

export const ArrowPopper = styled.div`
  position: absolute;
  width: 10px;
  height: 10px;
  background-color: ${({ theme }) => theme?.colors?.white};
  transform: rotate(45deg);
  z-index: 0;
  top: -5px;
  box-shadow: -1px -1px 1px rgba(0, 0, 0, 0.1);

  &[data-popper-placement^='bottom'] {
    top: -5px;
  }

  &[data-popper-placement^='top'] {
    bottom: -5px;
  }

  &[data-popper-placement^='left'] {
    right: -5px;
  }

  &[data-popper-placement^='right'] {
    left: -5px;
  }
`

export const BaseButton = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
`

export const StylePositionHotelCart = styled.div`
  width: 300px;
`

export const EmptyCart = styled.div`
  height: 185px;
  width: 100%;
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;

  h3,
  p {
    margin: 0;
  }

  h3 {
    margin-top: 20px;
    font-size: 13px;
    font-style: normal;
    font-weight: 800;
  }

  p {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
  }
`

export const TooltipDropCart = styled.div`
  align-items: flex-start;
  background: ${({ theme }) => theme?.colors?.success};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  padding: 20px;
  width: auto;

  p {
    color: #fff;
    display: flex;
    font-family: 'Manrope';
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    gap: 15px;
    line-height: normal;
    margin: 0;
  }
`

export const TooltipContent = styled.div`
  gap: 15px;
  width: auto;
  display: flex;

  p {
    margin: 0;
    color: ${({ theme }) => theme.colors?.white};
    display: flex;
    font-size: 14px;
    font-weight: 700;
    font-style: normal;
    line-height: normal;
    font-family: 'Manrope';
  }
`
